import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Grid,
  GridItem,
} from "@chakra-ui/react";

import { LicenseInfo } from "../../../../types/registerBranchDataTypes";
import { useBranch } from "../../../../data/user";

interface licenseStepProps {
  savedData: LicenseInfo | undefined; // Allow for undefined data
  updateData: (data: LicenseInfo) => void;
}

// function to format date to YYYY/MM/DD
const formatDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const parseDate = (dateString: string) => {
  const [day, month, year] = dateString.split("/").map(Number);
  return new Date(year, month - 1, day); // Months are 0-indexed in JavaScript Date
};

const toInputFormat = (date: Date): string => {
  return date.toISOString().split("T")[0]; // Extract 'YYYY-MM-DD'
};

const LicenseStep: React.FC<licenseStepProps> = ({ savedData, updateData }) => {
  // Fallback to empty object if savedData is undefined
  const licenseInfo = savedData ?? ({} as LicenseInfo);
  const { branch } = useBranch();

  return (
    <Box>
      <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={5}>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormControl isRequired>
            <FormLabel>Licence Number</FormLabel>
            <Input
              type="number"
              isInvalid={!licenseInfo.license_number} // validation
              value={licenseInfo.license_number || ""} // Fallback to empty string if undefined
              placeholder={branch === "UAE" ? "As per trade licensce" : ""}
              onChange={(e) => {
                updateData({
                  ...licenseInfo,
                  license_number: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>

        <GridItem colSpan={1}>
          <FormControl isRequired>
            <FormLabel>Licence Expiration Date</FormLabel>
            <Input
              type="date"
              isInvalid={!licenseInfo.license_expiration} // validation
              value={
                licenseInfo.license_expiration
                  ? toInputFormat(parseDate(licenseInfo.license_expiration))
                  : ""
              } // Handle undefined case
              onChange={(e) => {
                updateData({
                  ...licenseInfo,
                  license_expiration: formatDate(new Date(e.target.value)),
                });
              }}
            />
          </FormControl>
        </GridItem>

        <GridItem colSpan={{ base: 1, md: 2 }}>
          <FormControl>
            <FormLabel>VAT Number</FormLabel>
            <Input
              type="number"
              isInvalid={!licenseInfo.vat_number} // validation
              value={licenseInfo.vat_number || ""} // Fallback to empty string if undefined
              onChange={(e) => {
                updateData({
                  ...licenseInfo,
                  vat_number: e.target.value,
                });
              }}
            />
          </FormControl>
        </GridItem>

        <GridItem colSpan={1}>
          <FormControl>
            <FormLabel>VAT Expiration Date</FormLabel>
            <Input
              type="date"
              isInvalid={!licenseInfo.vat_expiration} // validation
              value={
                licenseInfo.vat_expiration
                  ? toInputFormat(parseDate(licenseInfo.vat_expiration))
                  : ""
              } // Handle undefined case
              onChange={(e) => {
                updateData({
                  ...licenseInfo,
                  vat_expiration: formatDate(new Date(e.target.value)),
                });
              }}
            />
          </FormControl>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default LicenseStep;
